import el from "@cypherpotato/el";
import { formatFloat, formatNumber } from "../ui/format";

export function Meter({ value, min = 0, max = 100, colorShade = false, props }) {
    const percentage =
        value <= min ? 0 :
            value >= max ? 100 :
                ((value - min) / (max - min)) * 100;

    const color = colorShade ? `hsl(${120 * (1 - percentage / 100)}, 100%, 50%)` : "var(--primary-color-100)";

    return el("div", { class: "meter", ...props },
        el(".meter-pill",
            el("div", { class: "meter-fill", style: { width: `calc(${percentage}% + 15px)`, backgroundColor: color } })
        ),
        el("span", { class: "meter-text" }, formatNumber(percentage), "%")
    );
}